import { DefaultToolsOverrides } from './DefaultToolsOverrides'
import { EditingShapeHandlers } from './EditingShapeHandlers'
import { FrameOverflowHandlers } from './FrameOverflowHandlers'
import { KeyboardShortcuts } from './KeyboardShortcuts'

export const Bootstrap = () => {
  return (
    <>
      <FrameOverflowHandlers />
      <DefaultToolsOverrides />
      <KeyboardShortcuts />
      <EditingShapeHandlers />
    </>
  )
}
